import { Env } from '@/env';
import { useStore } from './engine/store';
import { io, Socket } from 'socket.io-client';
import { applyServerTime, requestTimeSync } from './engine/clock';

const url = new URL(Env.VITE_WEBSOCKET_URL);
const origin = url.origin;
const basePath = url.pathname.replace(/\/$/, '');
const path = `${basePath}`;

export let socket: Socket | undefined;

let visibilityHandler: (() => void) | undefined;
let pageshowHandler: (() => void) | undefined;

export function initSocket(locationId: string) {
	closeSocket();

	socket = io(origin, {
		transports: ['websocket'],
		path: path,
		auth: {
			locationId,
		},
	});

	socket.on('game-state', (gameState) => {
		applyServerTime(gameState.serverTime);
		const state = useStore.getState();
		state.setGameState(gameState);
	});

	socket.on('update-game-state', (gameState) => {
		console.log('UPDATE GAME-STATE');
		applyServerTime(gameState.serverTime);
		const state = useStore.getState();
		if (state.location?.sessionId !== gameState.sessionId) {
			state.unsetPlayerState();
			state.setLocationSessionId(gameState.sessionId);
		}
		state.setGameState(gameState);
	});

	socket.on('disconnect-reason', (message) => {
		console.warn('Socket Disconnected: ' + message);
	});

	socket.on('connect', () => {
		requestTimeSync(socket!);
	});

	visibilityHandler = () => {
		if (document.visibilityState === 'visible' && socket) {
			requestTimeSync(socket);
		}
	};
	pageshowHandler = () => {
		if (document.visibilityState === 'visible' && socket) {
			requestTimeSync(socket);
		}
	};
	document.addEventListener('visibilitychange', visibilityHandler);
	window.addEventListener('pageshow', pageshowHandler);

	socket.connect();
}

export function closeSocket() {
	if (visibilityHandler) {
		document.removeEventListener('visibilitychange', visibilityHandler);
		visibilityHandler = undefined;
	}
	if (pageshowHandler) {
		window.removeEventListener('pageshow', pageshowHandler);
		pageshowHandler = undefined;
	}
	if (socket) {
		socket.disconnect();
		console.log('disconnecting old socket');
	}
}
